import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DashboardCSClient from "./DashboardCSClient";

// Not sure about these two
// import Basic from "./Basic";
import { LayoutSplashScreen } from "../../../_metronic";

export default function HomePageCSClient() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /taskdashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <Route path="/dashboard" component={DashboardCSClient} />

        {/* Reference Pages */}
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
